// App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { signInWithPopup, GoogleAuthProvider, signOut } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase.config.js';
import { AgencyProvider, useAgency } from './AgencyContext.js';

// Import des composants

import LoginOptions from './Connexion/LoginOptions.js';

import HeaderL1L2QA from './EmployeesSideMenu/HeaderL1L2QA.js';

import ExecuteTask from './Execute/ExecuteTask.js';
import Backlog from './Backlog/index.js';
import TaskID from './TaskLogic/TaskID.js';
import ManagerTaskView from './TaskLogic/ManagerTaskView.js';
import UserLeaderboard from './EmployeeStatistics/UserLeaderboard.js';
import SidePannelAdmin from './ManagerSideMenu/SidePannelAdmin.js';
import ManageUsers from './Users/ManageUsers.js';
import "./App.css";

import HelpCenter from './Helpcenter/HelpCenter.js';
import Chat from './Chat/';
import { Login } from '@mui/icons-material';


const AppContent = () => {
  const [user, loading] = useAuthState(auth);
  const { currentAgency, loading: agencyLoading, needsOnboarding, onboardingComplete } = useAgency();


  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error during sign out:', error);
    }
  };

  const handleAuthSuccess = (agencyKey) => {
    // Force refresh of agency context after successful auth
    onboardingComplete(agencyKey);
  };


  // Audit: Track login/logout
  useEffect(() => {
    if (user && currentAgency && !loading && !agencyLoading) {
      // User is logged in with agency
    }
  }, [user, currentAgency, loading, agencyLoading]);

  // Show loading while authenticating or checking agency
  if (loading || (user && agencyLoading)) {
    return (
      <div className="app-loading-empty"></div>
    );
  }

  // Show login options if not authenticated OR if user needs onboarding
  if (!user || needsOnboarding) {
    return <LoginOptions onAuthSuccess={handleAuthSuccess} />;
  }


  return (
    <Router>
      <Routes>
        {/* Accessible sans être connecté */}


        {/* Note: LoginOptions is now handled above, this section is for authenticated users only */}
        {/* Routes protégées - utilisateur connecté avec agence */}
        
        {user && currentAgency && (
          <Route
            path="*"
            element={
              <div className="app">
                {(currentAgency.userRole === 'admin' || currentAgency.userRole === 'manager' || currentAgency.userRole === 'Manager') ? (
                  null
                ) : (
                  <HeaderL1L2QA user={user} userRole={currentAgency.userRole} onSignOut={handleSignOut} />
                )}
                <main className="app-main">
                  <Routes>
                    <Route path="/" element={
                      (currentAgency.userRole === 'admin' || currentAgency.userRole === 'manager' || currentAgency.userRole === 'Manager') 
                        ? <SidePannelAdmin />
                        : <Navigate to="/backlog" replace />
                    } />
               
                    
                    {/* Routes admin - accessibles uniquement aux admins et managers */}
                    {(currentAgency.userRole === 'admin' || currentAgency.userRole === 'manager' || currentAgency.userRole === 'Manager') && (
                      <>
                        <Route path="/admin" element={<SidePannelAdmin />} />
                        <Route path="/Admin" element={<SidePannelAdmin />} />
                        <Route path="/executetask" element={<SidePannelAdmin />} />
                        <Route path="/chat" element={<SidePannelAdmin />} />
                        <Route path="/promptautomator" element={<SidePannelAdmin />} />
                        <Route path="/captionautomator" element={<SidePannelAdmin />} />
                        <Route path="/explore" element={<SidePannelAdmin />} />
                        <Route path="/tasktrack" element={<SidePannelAdmin />} />
                        <Route path="/finance" element={<SidePannelAdmin />} />
                        <Route path="/simpgpt" element={<SidePannelAdmin />} />
                        <Route path="/todolist" element={<SidePannelAdmin />} />
                        <Route path="/manage-users" element={<ManageUsers user={user}/>} />
                        <Route path="/help" element={<SidePannelAdmin />} />
                      </>
                    )}
                    
                    {/* Routes backlog pour tous */}
                    <Route path="/backlog" element={
                      (currentAgency.userRole === 'admin' || currentAgency.userRole === 'manager' || currentAgency.userRole === 'Manager') 
                        ? <SidePannelAdmin />
                        : <Backlog />
                    } />
                    <Route path="/Backlog" element={
                      (currentAgency.userRole === 'admin' || currentAgency.userRole === 'manager' || currentAgency.userRole === 'Manager') 
                        ? <SidePannelAdmin />
                        : <Backlog />
                    } />
                    <Route path="/execute-task" element={<ExecuteTask />} />
                    <Route path="/task/:id" element={<ManagerTaskView />} />
                    <Route path="/statistics" element={<UserLeaderboard user={user} />} />
                    {/* Route chat pour tous */}
                    <Route path="/chat" element={
                      (currentAgency.userRole === 'admin' || currentAgency.userRole === 'manager' || currentAgency.userRole === 'Manager') 
                        ? <SidePannelAdmin />
                        : <Chat />
                    } />
                    {/* <Route path="/testing" element={<Onboarding />} /> */}
                   {/*   */}
                    {/* Route help pour les utilisateurs non-admin */}
                    {!(currentAgency.userRole === 'admin' || currentAgency.userRole === 'manager' || currentAgency.userRole === 'Manager') && (
                      <Route path="/help" element={<HelpCenter />} />
                    )}
                    
                    {/* Redirection par défaut */}
                    <Route path="*" element={
                      <Navigate to={
                        (currentAgency.userRole === 'admin' || currentAgency.userRole === 'manager' || currentAgency.userRole === 'Manager') 
                          ? "/" 
                          : "/backlog"
                      } replace />
                    } />
                  </Routes>
                </main>
              </div>
            }
          />
        )}
      </Routes>
    </Router>
  );
};

const App = () => {
  return (
    <AgencyProvider>
      <AppContent />
    </AgencyProvider>
  );
};

export default App;